const BioTexts = {
  fr: [
    `Qui est Ben Bridgen ?`,

    `Pas si simple à définir… Compositeur ? Oui. Instrumentiste ? Oui. Pianiste, guitariste,
bassiste, percussionniste, chanteur ? Oui, oui, oui. Arrangeur ? Oui. Ingénieur du son ?
Oui !`,

    `Avec un pied sur son île maternelle de Grande-Bretagne et l’autre dans sa French Life, il
navigue entre cultures et influences pour explorer de multiples styles musicaux. Pas de
frontières avec Ben Bridgen : on fait de la musique comme on voyage, d’album en album.`,

    `Ses créations résonnent sur différents terrains : dans son studio, sur scène avec des
groupes, pour le spectacle vivant, dans l’accompagnement de la pratique amateur, mais
aussi pour des projets audiovisuels, radio et télévision, des bandes-annonces, jingles ou
dessins animés.`,

    `(texte de Julie Cloarec-Michaud)`,
  ],

  en: [
    `Who is Ben Bridgen?`,
    `Not so easy to define… Composer? Yes. Multi-instrumentalist? Yes. Pianist, guitarist,
bassist, percussionist, singer? Yes, yes, yes. Arranger? Yes. Sound engineer? Yes!`,

    `With one foot in his native Great Britain and the other in his French Life, he navigates
between cultures and influences to explore a wide range of musical styles. No borders with
Ben Bridgen: he makes music as he travels, from album to album.`,

    `His creations resonate across different settings: in his studio, on stage with bands, for live
performance, accompanying amateur musicians, and also for audiovisual projects, radio
and television, trailers, jingles, or animation`,

    `(written by Julie Cloarec-Michaud)`,
  ],
  buttons: {
    fr: {
      collaboration: "Collaborations",
      video: "Voir la vidéo",
      backToBio: "Retour à la bio",
    },
    en: {
      collaboration: "Collaborations",
      video: "Watch the video",
      backToBio: "Back to bio",
    },
  },
};

export default BioTexts;
